import { createContext } from 'react';

export const ThemeContext = createContext(
  Boolean(document.querySelector('meta[name="viewport"]'))
);
